import { isRef } from 'vue';

export default function useExposeProperties(target: any, source: any) {
	// 🔹 Verificar _enabled antes da exposição
	// console.log('useExposeProperties: _enabled antes:', source._enabled, 'isRef:', isRef(source._enabled));

	// 🔹 Propriedades diretas da instância
	const ownProps = Object.getOwnPropertyNames(source);

	for (const prop of ownProps) {
		if (prop.startsWith('_')) continue;

		const descriptor = Object.getOwnPropertyDescriptor(source, prop);

		if (descriptor?.get || descriptor?.set) {
			Object.defineProperty(target, prop, {
				get: descriptor.get?.bind(source),
				set: descriptor.set?.bind(source),
				enumerable: true,
				configurable: true
			});
		} else if (typeof source[prop] === 'function') {
			target[prop] = source[prop].bind(source);
		} else {
			Object.defineProperty(target, prop, {
				get: () => source[prop],
				set: (val) => { source[prop] = val },
				enumerable: true,
				configurable: true
			});
		}
	}

	// 🔹 Propriedades do protótipo (herança)
	let proto = Object.getPrototypeOf(source);
	while (proto && proto !== Object.prototype) {
		const protoProps = Object.getOwnPropertyNames(proto);

		for (const prop of protoProps) {
			if (prop === 'constructor') continue;
			if (prop in target) continue;

			const descriptor = Object.getOwnPropertyDescriptor(proto, prop);

			if (descriptor?.get || descriptor?.set) {
				Object.defineProperty(target, prop, {
					get: descriptor.get?.bind(source),
					set: descriptor.set?.bind(source),
					enumerable: true,
					configurable: true
				});
			} else if (typeof proto[prop] === 'function') {
				target[prop] = proto[prop].bind(source);
			}
		}

		proto = Object.getPrototypeOf(proto);
	}

	// 🔹 Verificar _enabled após a exposição
	// console.log('useExposeProperties: _enabled após:', source._enabled, 'isRef:', isRef(source._enabled));
}
